import { Tab as FractalTab } from '@snowball-tech/fractal/dist/src/components/Tabs'

import type { MediaTypes } from '../../../types'

import { AllowedMediaSources } from '../../../enums'
import useTranslations from '../../../hooks/useTranslations'
import Tab from './Tab'

type Props = {
  allowedSources: Array<AllowedMediaSources>
  type: MediaTypes
  showDeleteTab?: boolean
}
export default function Tabs({
  allowedSources,
  showDeleteTab = true,
  type,
}: Props) {
  const $t = useTranslations()

  return (
    <>
      {allowedSources.map((provider) => (
        <Tab key={provider} name={provider} type={type} />
      ))}
      {showDeleteTab && (
        <FractalTab
          label={$t(`editor.${type}.loader.delete.tab`)}
          name="delete"
        />
      )}
    </>
  )
}
